
<template>
   <div>       
        <b-dropdown :text="choosed" :disabled="disabled">
            <b-dropdown-item href="#" v-for="(value, key) in obj" @click="select(key, value)">
                {{ value }}
            </b-dropdown-item>
        </b-dropdown>        
    </div>
</template>

<script>


    export default {
        props: {
            obj:{
                type:Object,
                required:true
            },
            id: {
                required: true,
                type:String
            },
            value:{
                type: Number|String,
                required:false
            },
            unset_label:{
                type:String,
                default: "Action"
            },
            BtnClass: {
                type:String|Object,
                required: false,
                default:"btn-gray"
            },
            BtnStyle: {
                type:String|Object,
                required: false,
                default:""
            },
            RawKey: {
                type: Boolean,
                required: false,
                default: false
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data(){
            return {
                isOpen: false
            }
        },
        computed: {
            choosed(){

                if (this.obj[this.value]) return this.obj[this.value];
                var regEx = /^\d{2}.\d{2}.\d{4}/;
                if(($.type(this.value) === "string") && this.value.match(regEx)) return this.value.split(',')[0];

                //if (Date.parse(this.value)) return this.value;
               //let k = this.obj.keys().findIndex(o=>o == this.value);
                //if (k>=0) return this.obj[k];
                return this.unset_label;
            }
        },
        methods:{
            select(key, value){
                this.isOpen=false;
                if (this.RawKey)
                    this.$emit("input", key)
                else
                    this.$emit("input",parseInt(key))
                return false;
            }
        },
        name:"Dropdown"
    };

</script>

